import { Data, Schema } from 'effect'

export const varietals = Data.array([
  'Aji',
  'Aramosa',
  'Bourbon',
  'Castillo',
  'Catimor',
  'Catuai',
  'Caturra',
  'Colombia',
  'F1 Hybrids',
  'Geisha',
  'Heirloom (Ethiopian Varietals)',
  'Java',
  'Kenyan cultivars (SL28, SL34, Ruiru, Batian)',
  'Laurina',
  'Mandela',
  'Maragogype',
  'Mundo Novo',
  'Pacamara',
  'Pink Bourbon',
  'Sidra',
  'Sudan Rume',
  'Typica',
  'Typica Mejorado',
  'Wush Wush',
  'Yemenia',
  'Other',
] as const)

export const Varietal = Schema.Literal(...varietals)
